import React, { useState, useEffect } from 'react';
import {
  isClient,
  getSectionId,
} from '../../utils/helpers';
import {
  NavigationItem,
} from '.';
import './LegalPageNavigation.scss';

const scrollToPageSection = (event, sectionId) => {
  if (event) event.preventDefault();
  const targetEl = document.getElementById(sectionId);
  if (targetEl) targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const LegalPageNavigation = (props) => {
  const {
    activeSection,
    sections,
  } = props;
  const [navOpen, setNavOpen] = useState(false);
  const sectionTitles = sections && sections.map(section => section.sectionHeading.text);
  useEffect(() => {
    const navChecker = async () => {
      if (navOpen) setNavOpen(false);
    };
    if (isClient) window.addEventListener('scroll', navChecker);
    return () => {
      if (isClient) window.addEventListener('scroll', navChecker);
    };
  });
  return (
    <nav
      className="legal-page-navigation"
    >
      <div className="navigation-container">
        <ul
          className={`nav-items${navOpen ? ' nav-open' : ''}`}
        >
          {sectionTitles && sectionTitles.map((sectionTitle, index) => (
            <NavigationItem
              key={getSectionId(index, sectionTitle)}
              isActive={activeSection === index}
              sectionTitle={sectionTitle}
              index={index}
              scrollToHandler={scrollToPageSection}
            />
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default LegalPageNavigation;
